module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "events"
  }, [_c('div', {
    staticClass: "events_section",
    attrs: {
      "id": "events"
    }
  }, [_c('div', {
    staticClass: "events_section_container"
  }, [_c('div', {
    staticClass: "events_section_container_event"
  }, [_c('img', {
    staticClass: "events_section_container_event_img",
    attrs: {
      "src": _vm.larps[2].img
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "events_section_container_event_title"
  }, [_vm._v("\n          " + _vm._s(_vm.larps[2].title) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "events_section_container_event_descriptio"
  }, [_vm._v("\n          Frakcja: " + _vm._s(_vm.larps[2].fraction)), _c('br'), _vm._v("\n          Cel: " + _vm._s(_vm.larps[2].target) + " "), _c('br'), _c('br'), _vm._v("\n          " + _vm._s(_vm.larps[2].description) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "events_section_container"
  }, [_c('div', {
    staticClass: "events_section_container_event"
  }, [_c('img', {
    staticClass: "events_section_container_event_img",
    attrs: {
      "src": _vm.larps[1].img
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "events_section_container_event_title"
  }, [_vm._v("\n          " + _vm._s(_vm.larps[1].title) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "events_section_container_event_descriptio"
  }, [_vm._v("\n          Frakcja: " + _vm._s(_vm.larps[1].fraction)), _c('br'), _vm._v("\n          Cel: " + _vm._s(_vm.larps[1].target) + " "), _c('br'), _c('br'), _vm._v("\n          " + _vm._s(_vm.larps[1].description) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "events_section_container"
  }, [_c('div', {
    staticClass: "events_section_container_event"
  }, [_c('img', {
    staticClass: "events_section_container_event_img",
    attrs: {
      "src": _vm.larps[0].img
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "events_section_container_event_title"
  }, [_vm._v("\n          " + _vm._s(_vm.larps[0].title) + "\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "events_section_container_event_descriptio"
  }, [_vm._v("\n          Frakcja: " + _vm._s(_vm.larps[0].fraction)), _c('br'), _vm._v("\n          Cel: " + _vm._s(_vm.larps[0].target) + " "), _c('br'), _c('br'), _vm._v("\n          " + _vm._s(_vm.larps[0].description) + "\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55370622"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/events.vue
// module id = 30
// module chunks = 0